export const PEOPLE_MANAGEMENT_LEAVE_BALANCE_READ = 'PEOPLE_MANAGEMENT_LEAVE_BALANCE_READ';

export const LEAVE_BALANCE_CACHE_NAME = 'leaveBalanceNew';

export const DAY_ON_DEMAND_TOTAL_BALANCE = 4;

export const EMPLOYEE_CONTRACT_TYPE_ALIASES = {
  EC: 'EC',
} as const;
